import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { MyTimestampPipe } from '@shared/pipes';
import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-accessDenied',
    'templateUrl': './accessDenied.page.html',
    'styleUrls': ['./accessDenied.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyTimestampPipe ]
})
export class AccessDeniedPage extends ViewBasePage implements OnInit {
    public accessDenied: any = {};

    constructor(injector: Injector) {
        super(injector);
        super.setCurrentView(Constants.VIEW_ACCESS_DENIED);
    }

    public override ngOnInit(): void {
        const website = `<a href="https://shuttlenomix.com" target="_blank">ShuttleNomix website</a>`;
        // e a one-week trial period extension.</li>' +

        const accountProfile = this.sessionService.getAccountProfile();

        this.accessDenied.accountNumber = this.sessionService.getAccountNumber();
        this.accessDenied.expirationDate = accountProfile.periodInfo.expirationDate;
        this.accessDenied.packageName = accountProfile.packageName;
        this.accessDenied.phoneNumber = Constants.COMPANY_PHONE_NUMBER;
        this.accessDenied.companyHours = Constants.COMPANY_HOURS;
        this.accessDenied.website = website;    // Constants.COMPANY_WEBSITE;

        // if (this.sessionService.getIsCustomer()) {
        switch (accountProfile.status) {
            case 'Cancelled By Support':
                this.accessDenied.callToAction = Constants.ACCESS_DENIED_CANCELLED_BY_SUPPORT;
                break;

            case 'Cancelled By Customer':
                this.accessDenied.callToAction = Constants.ACCESS_DENIED_CANCELLED_BY_USER;
                break;

            case 'Package Expired':
                this.accessDenied.callToAction = Constants.ACCESS_DENIED_PACKAGE_EXPIRED;
                break;

            case 'Trial Period Expired':
                this.accessDenied.callToAction = Constants.ACCESS_DENIED_TRIAL_PERIOD_EXPIRED;
                break;
        }
    }
}

